import React from "react";
import { Link } from "react-router-dom";
import { openCookiePreferences } from "@/lib/cookieConsent";
import { Mail } from "lucide-react";
import { Logo } from "@/components/common/Logo";
import { SOCIALS } from "@/lib/socials";

const cols = [
  {
    title: "Directory",
    links: [
      { to: "/people", label: "People" },
      { to: "/businesses", label: "Businesses" },
      { to: "/capital", label: "Capital" },
      { to: "/groups", label: "Groups" },
      { to: "/resources", label: "Resources" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/features", label: "Features" },
      { to: "/about", label: "About" },
      { to: "/contact", label: "Contact" },
      { to: "/partner", label: "Partner" },
      { to: "/pricing", label: "Pricing" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/terms", label: "Terms of Service" },
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/returns", label: "Returns Policy" },
      { to: "/accessibility", label: "Accessibility" },
      { to: "/affiliate", label: "Affiliate Policy" },
    ],
  },
];

export const Footer = () => (
  <footer className="border-t border-border bg-card">
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
        <div className="col-span-2 md:col-span-1">
          <Logo />
          <p className="mt-3 max-w-xs text-sm text-muted-foreground">
            The directory and network for founders, businesses, and capital.
          </p>
          <div className="mt-4 flex flex-wrap items-center gap-3" data-testid="footer-socials">
            {SOCIALS.map(({ href, label, testId, Icon, disabled }) => (
              <a
                key={testId}
                href={href}
                target={disabled ? undefined : "_blank"}
                rel={disabled ? undefined : "noreferrer"}
                aria-label={label}
                title={label}
                data-testid={`footer-${testId}`}
                onClick={disabled ? (e) => e.preventDefault() : undefined}
                className={`text-muted-foreground transition-colors hover:text-primary ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
              >
                <Icon className="h-5 w-5" />
              </a>
            ))}
            <a href="mailto:hello@startupotter.com" className="text-muted-foreground hover:text-primary" aria-label="Email" data-testid="footer-social-email"><Mail className="h-5 w-5" /></a>
          </div>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="text-sm font-[640] text-foreground">{c.title}</h4>
            <ul className="mt-3 space-y-2">
              {c.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-muted-foreground hover:text-primary">{l.label}</Link>
                </li>
              ))}
              {c.title === "Legal" && (
                <li>
                  <button type="button" onClick={openCookiePreferences}
                    className="text-left text-sm text-muted-foreground hover:text-primary"
                    data-testid="footer-cookie-preferences">Cookie Preferences</button>
                </li>
              )}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-border pt-6 sm:flex-row">
        <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} Startup Otter. All rights reserved.</p>
        <p className="text-xs text-muted-foreground">Made for the startup ecosystem.</p>
      </div>
    </div>
  </footer>
);
